module.exports = __webpack_public_path__ + "static/media/icono-knorr-uy-compradores-corregido.2d4fa501.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icono-knorr-uy-compradores-corregido.png
// module id = 311
// module chunks = 0